module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/convenios/detalles/components/archivo-convenio/archivo-convenio.component.scss
// module id = ./src/app/convenios/detalles/components/archivo-convenio/archivo-convenio.component.scss
// module chunks = main